export default __webpack_public_path__ + "static/media/servicies-registration.icon.3705935a.svg";